import React from "react";
import {observer} from "mobx-react";

const Avatar = ({userStore}) => {
  const {userName} = userStore || {};
  return userName && (
    <div className={"avatar"}>
      <span>{userName?.slice(0, 2)}</span>
    </div>
  );
};

export default observer(Avatar);
